module.exports = __webpack_public_path__ + "img/enisina_dual.f582dedb.png";